import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-5a213368")
const _hoisted_1 = { id: "rotate-component" }
const _hoisted_2 = { id: "rotate-wrap" }
const _hoisted_3 = { id: "orientation-select" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Landscape", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Portrait", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolTitle = _resolveComponent("ToolTitle")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ToolTitle, { title: _ctx.title }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "orientation",
          ref: "landscape",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.choseOrientation('Landscape')))
        }, [
          _createVNode(_component_font_awesome_icon, {
            class: "tool-icon",
            icon: "file",
            rotation: "90",
            "aria-hidden": "true"
          }),
          _hoisted_4
        ], 512),
        _createElementVNode("div", {
          class: "orientation",
          ref: "portrait",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.choseOrientation('Portrait')))
        }, [
          _createVNode(_component_font_awesome_icon, {
            class: "tool-icon",
            icon: "file",
            "aria-hidden": "true"
          }),
          _hoisted_5
        ], 512)
      ])
    ])
  ]))
}